import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import PDPFabricReviewsUI from './PDPFabricReviewsUI';
const PDPFabricReviews = t0 => {
  const $ = _c(2);
  const {
    reviews
  } = t0;
  let t1;
  if ($[0] !== reviews) {
    t1 = <PDPFabricReviewsUI reviews={reviews} />;
    $[0] = reviews;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
PDPFabricReviews.propTypes = {
  reviews: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
};
export default PDPFabricReviews;